import styled from '@emotion/styled'

export const StyledSystem = styled.div`


    display: flex;
    flex-direction: column;
    gap: 40px;

`